// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingsNavItem {
    display: inline-block;
    padding: 15px;
    color: inherit;
    text-decoration: none;
}

.settingsNavItem:hover {
    background-color: rgb(197, 197, 197);
    color: initial;
    border-radius: 10px;
}

.my-0 {
    margin: 0;
}

/* Settings index hub (aligned with Reports hub styling) */
.settings-hub {
    padding: 8px 0 48px;
    max-width: 960px;
}

.settings-hub__intro {
    margin: 0 0 24px;
    font-size: 0.9375rem;
    line-height: 1.55;
    color: rgba(197, 197, 197, 0.92);
}

.settings-hub__scope {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 28px;
    padding: 8px 14px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.2);
    font-size: 0.8125rem;
    color: rgba(197, 197, 197, 0.88);
}

.settings-hub__scope-label {
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    font-size: 0.65rem;
    color: rgba(192, 159, 83, 0.95);
}

.settings-hub__scope-value {
    font-weight: 500;
    color: #ececec;
    word-break: break-word;
}

.settings-hub__empty {
    margin: 0;
    font-size: 0.875rem;
    color: rgba(180, 180, 180, 0.9);
}

.settings-hub__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 16px;
}

.settings-hub__card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    padding: 20px 20px 18px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(165deg, rgba(58, 58, 62, 0.55) 0%, rgba(36, 36, 40, 0.75) 100%);
    box-shadow:
        0 12px 32px rgba(0, 0, 0, 0.22),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
    text-decoration: none;
    color: inherit;
    transition:
        border-color 0.2s ease,
        background 0.2s ease,
        transform 0.2s ease,
        box-shadow 0.2s ease;
}

.settings-hub__card:hover {
    border-color: rgba(192, 159, 83, 0.35);
    background: linear-gradient(165deg, rgba(68, 64, 58, 0.45) 0%, rgba(40, 38, 34, 0.85) 100%);
    box-shadow:
        0 16px 40px rgba(0, 0, 0, 0.28),
        inset 0 1px 0 rgba(255, 255, 255, 0.06);
    transform: translateY(-1px);
}

.settings-hub__card:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.65);
    outline-offset: 3px;
}

.settings-hub__card-title {
    margin: 0 0 8px;
    font-size: 1.05rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: #f2f2f2;
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.settings-hub__card-arrow {
    flex-shrink: 0;
    width: 10px;
    height: 10px;
    margin-left: auto;
    border-right: 2px solid rgba(192, 159, 83, 0.75);
    border-bottom: 2px solid rgba(192, 159, 83, 0.75);
    transform: rotate(-45deg);
    margin-top: 2px;
}

.settings-hub__card-desc {
    margin: 0;
    font-size: 0.8125rem;
    line-height: 1.5;
    color: rgba(180, 180, 180, 0.95);
}

@media screen and (max-width: 600px) {
    .settings-hub__grid {
        grid-template-columns: 1fr;
    }
}

/* ——— Shared layout for Settings subpages ——— */
.settings-subpage {
    max-width: 720px;
    padding: 8px 0 56px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

.settings-subpage--wide {
    max-width: 960px;
}

.settings-subpage__intro {
    margin: 0 0 20px;
    font-size: 0.9375rem;
    line-height: 1.55;
    color: rgba(197, 197, 197, 0.9);
}

.settings-subpage__toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px 20px;
    margin-bottom: 18px;
}

.settings-subpage__toolbar .cta {
    margin-top: 0;
}

.settings-subpage__back {
    display: inline-flex;
    align-items: center;
    margin-bottom: 18px;
    font-size: 0.875rem;
    font-weight: 500;
    color: #8f9aad;
    text-decoration: none;
    border-bottom: 1px solid transparent;
    transition:
        color 0.2s ease,
        border-color 0.2s ease;
}

.settings-subpage__back:hover {
    color: #c0a053;
    border-bottom-color: rgba(192, 159, 83, 0.45);
}

.settings-subpage__panel {
    padding: 22px 22px 24px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(165deg, rgba(52, 52, 56, 0.55) 0%, rgba(28, 28, 32, 0.72) 100%);
    box-shadow:
        0 12px 32px rgba(0, 0, 0, 0.22),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
    margin-bottom: 20px;
}

.settings-subpage__panel--flush {
    padding: 0;
    overflow: hidden;
}

.settings-subpage__status {
    margin: 0 0 16px;
    padding: 10px 14px;
    border-radius: 10px;
    font-size: 0.875rem;
    background: rgba(192, 159, 83, 0.12);
    border: 1px solid rgba(192, 159, 83, 0.25);
    color: #e8dcc8;
}

.settings-subpage__status--error {
    background: rgba(220, 80, 80, 0.12);
    border-color: rgba(220, 100, 100, 0.35);
    color: #f0c4c4;
}

.settings-subpage__form {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.settings-subpage__field-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 20px;
}

.settings-subpage__field-row label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #d8d8d8;
    min-width: 140px;
}

.settings-subpage__select {
    flex: 1;
    min-width: 200px;
    padding: 10px 12px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(0, 0, 0, 0.25);
    color: #f0f0f0;
    font-size: 0.875rem;
    font-family: inherit;
}

.settings-subpage__select:focus {
    outline: none;
    border-color: rgba(192, 159, 83, 0.45);
    box-shadow: 0 0 0 2px rgba(192, 159, 83, 0.15);
}

.settings-subpage__submit,
.settings-subpage .cta {
    align-self: flex-start;
    margin-top: 8px;
    padding: 11px 22px;
    border-radius: 10px;
    border: 1px solid rgba(192, 159, 83, 0.45);
    background: linear-gradient(180deg, rgba(192, 159, 83, 0.22) 0%, rgba(160, 130, 70, 0.18) 100%);
    color: #f5f0e6;
    font-size: 0.875rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition:
        border-color 0.2s ease,
        background 0.2s ease,
        transform 0.15s ease;
}

.settings-subpage__submit:hover,
.settings-subpage .cta:hover {
    border-color: rgba(192, 159, 83, 0.65);
    background: linear-gradient(180deg, rgba(192, 159, 83, 0.32) 0%, rgba(160, 130, 70, 0.26) 100%);
}

.settings-subpage__submit:focus-visible,
.settings-subpage .cta:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.65);
    outline-offset: 2px;
}

.settings-subpage__submit:disabled,
.settings-subpage .cta:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    transform: none;
}

/* Data tables (users, organisations) */
.settings-table-wrap {
    margin-top: 8px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.2);
    overflow-x: auto;
}

.settings-table {
    width: 100%;
    min-width: 560px;
    border-collapse: collapse;
    font-size: 0.875rem;
    color: #e0e0e0;
}

.settings-table th {
    text-align: left;
    padding: 12px 16px;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.95);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.25);
}

.settings-table td {
    padding: 14px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    vertical-align: middle;
}

.settings-table tr:last-child td {
    border-bottom: none;
}

.settings-table tbody tr:hover td {
    background: rgba(255, 255, 255, 0.03);
}

.settings-table .cta {
    margin-top: 0;
    padding: 8px 14px;
    font-size: 0.8125rem;
}

.settings-subpage__empty {
    margin: 0;
    padding: 24px 16px;
    text-align: center;
    font-size: 0.875rem;
    color: rgba(180, 180, 180, 0.85);
}

/* Blacklist IP (page-specific, dark theme) */
.settings-blacklist__toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
    padding: 16px 18px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(165deg, rgba(52, 52, 56, 0.5) 0%, rgba(28, 28, 32, 0.65) 100%);
}

.settings-blacklist__toolbar p {
    margin: 0;
    font-size: 0.875rem;
    color: rgba(197, 197, 197, 0.92);
    line-height: 1.45;
}

.settings-blacklist__ip {
    font-weight: 600;
    color: #c0a053;
}

.settings-blacklist__add {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    border: 1px solid rgba(192, 159, 83, 0.4);
    background: rgba(192, 159, 83, 0.15);
    color: #f0e6d2;
    font-size: 1.5rem;
    line-height: 1;
    cursor: pointer;
    transition:
        background 0.2s ease,
        border-color 0.2s ease;
}

.settings-blacklist__add:hover {
    background: rgba(192, 159, 83, 0.28);
    border-color: rgba(192, 159, 83, 0.6);
}

.settings-blacklist__list {
    list-style: none;
    margin: 0;
    padding: 8px 0;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.22);
}

.settings-blacklist__item {
    padding: 12px 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    font-family: ui-monospace, monospace;
    font-size: 0.875rem;
    color: #e4e4e4;
}

.settings-blacklist__item:last-child {
    border-bottom: none;
}

.settings-blacklist-modal {
    position: fixed;
    inset: 0;
    z-index: 220;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(0, 0, 0, 0.65);
    backdrop-filter: blur(6px);
}

.settings-blacklist-modal__card {
    width: 100%;
    max-width: 420px;
    padding: 24px 22px 22px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: linear-gradient(168deg, rgba(48, 48, 52, 0.98) 0%, rgba(24, 24, 28, 0.99) 100%);
    box-shadow: 0 24px 56px rgba(0, 0, 0, 0.5);
}

.settings-blacklist-modal__card h2 {
    margin: 0 0 16px;
    font-size: 1.1rem;
    font-weight: 600;
    color: #f2f2f2;
}

.settings-blacklist-modal__card input {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    margin-bottom: 16px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(0, 0, 0, 0.35);
    color: #f0f0f0;
    font-size: 0.875rem;
    font-family: ui-monospace, monospace;
}

.settings-blacklist-modal__card input:focus {
    outline: none;
    border-color: rgba(192, 159, 83, 0.5);
}

.settings-blacklist-modal__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-end;
}

.settings-blacklist-modal__btn {
    padding: 10px 18px;
    border-radius: 10px;
    font-size: 0.875rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.06);
    color: #e0e0e0;
}

.settings-blacklist-modal__btn--primary {
    border-color: rgba(192, 159, 83, 0.45);
    background: rgba(192, 159, 83, 0.2);
    color: #faf6ee;
}

.settings-blacklist-modal__btn--danger {
    border-color: rgba(220, 100, 100, 0.5);
    background: rgba(160, 50, 50, 0.22);
    color: #ffd8d8;
}

.settings-blacklist-modal__btn:hover {
    filter: brightness(1.08);
}

.settings-org-modal__divider {
    margin: 20px 0 14px;
    border: none;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.settings-org-modal__danger-title {
    margin: 0 0 8px;
    font-size: 0.6875rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(255, 160, 160, 0.85);
}

.settings-org-modal__danger-desc {
    margin: 0 0 12px;
    font-size: 0.8125rem;
    line-height: 1.45;
    color: rgba(190, 190, 190, 0.95);
}

.settings-blacklist-modal__card .settings-org-modal__text-input {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.settings-blacklist-modal__card .settings-org-modal__select {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    margin-bottom: 14px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(0, 0, 0, 0.35);
    color: #f0f0f0;
    font-size: 0.875rem;
    font-family: inherit;
    cursor: pointer;
}

.settings-blacklist-modal__card .settings-org-modal__select:focus {
    outline: none;
    border-color: rgba(192, 159, 83, 0.5);
}

.settings-org-modal__field-block {
    margin-bottom: 14px;
}

.settings-org-modal__label {
    display: block;
    margin-bottom: 6px;
    font-size: 0.8125rem;
    font-weight: 600;
    color: #c8c8c8;
}

/* Workspace-specific styles */
.settings-workspace__domain {
    font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
    font-size: 0.8125rem;
    color: #c0a053;
    background: rgba(192, 159, 83, 0.1);
    padding: 3px 8px;
    border-radius: 6px;
    border: 1px solid rgba(192, 159, 83, 0.2);
}

.settings-workspace__description {
    color: rgba(180, 180, 180, 0.85);
    font-size: 0.8125rem;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
}

.settings-workspace__badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 8px;
    font-size: 0.6875rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.settings-workspace__badge--agency {
    background: rgba(192, 159, 83, 0.15);
    border: 1px solid rgba(192, 159, 83, 0.3);
    color: #c0a053;
}

.settings-workspace__user-count {
    font-size: 0.8125rem;
    color: rgba(180, 180, 180, 0.85);
}

/* Wider modal for workspaces */
.settings-blacklist-modal__card--wide {
    max-width: 520px;
}

/* User management section */
.settings-workspace__users-section {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.settings-workspace__users-add {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
}

.settings-workspace__user-input {
    flex: 1;
    margin-bottom: 0 !important;
}

.settings-workspace__add-user-btn {
    flex-shrink: 0;
    padding: 10px 16px;
    border-radius: 10px;
    border: 1px solid rgba(192, 159, 83, 0.45);
    background: rgba(192, 159, 83, 0.18);
    color: #f5f0e6;
    font-size: 0.875rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;
}

.settings-workspace__add-user-btn:hover {
    background: rgba(192, 159, 83, 0.28);
    border-color: rgba(192, 159, 83, 0.6);
}

.settings-workspace__add-user-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.settings-workspace__users-list {
    list-style: none;
    margin: 0;
    padding: 0;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.2);
    max-height: 180px;
    overflow-y: auto;
}

.settings-workspace__user-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.settings-workspace__user-item:last-child {
    border-bottom: none;
}

.settings-workspace__user-email {
    font-size: 0.8125rem;
    color: #e4e4e4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.settings-workspace__remove-user-btn {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    border: 1px solid rgba(220, 100, 100, 0.3);
    background: rgba(220, 80, 80, 0.12);
    color: #f0c4c4;
    font-size: 1rem;
    line-height: 1;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;
}

.settings-workspace__remove-user-btn:hover {
    background: rgba(220, 80, 80, 0.25);
    border-color: rgba(220, 100, 100, 0.5);
}

.settings-workspace__remove-user-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.settings-workspace__no-users {
    margin: 0;
    padding: 14px;
    font-size: 0.8125rem;
    color: rgba(180, 180, 180, 0.7);
    text-align: center;
    border-radius: 10px;
    border: 1px dashed rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
}

/* Domain management section */
.settings-workspace__domains-section {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.settings-workspace__domains-add {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
}

.settings-workspace__domain-input {
    flex: 1;
    margin-bottom: 0 !important;
}

.settings-workspace__add-domain-btn {
    flex-shrink: 0;
    padding: 10px 16px;
    border-radius: 10px;
    border: 1px solid rgba(192, 159, 83, 0.45);
    background: rgba(192, 159, 83, 0.18);
    color: #f5f0e6;
    font-size: 0.875rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;
}

.settings-workspace__add-domain-btn:hover {
    background: rgba(192, 159, 83, 0.28);
    border-color: rgba(192, 159, 83, 0.6);
}

.settings-workspace__add-domain-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.settings-workspace__domains-list {
    list-style: none;
    margin: 0;
    padding: 0;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.2);
    max-height: 180px;
    overflow-y: auto;
}

.settings-workspace__domain-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    gap: 10px;
}

.settings-workspace__domain-item:last-child {
    border-bottom: none;
}

.settings-workspace__domain-info {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    flex: 1;
}

.settings-workspace__domain-name {
    font-size: 0.8125rem;
    font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
    color: #e4e4e4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.settings-workspace__primary-badge {
    flex-shrink: 0;
    font-size: 0.625rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: 2px 6px;
    border-radius: 4px;
    background: rgba(192, 159, 83, 0.25);
    border: 1px solid rgba(192, 159, 83, 0.4);
    color: #c0a053;
}

.settings-workspace__domain-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
}

.settings-workspace__set-primary-btn {
    padding: 4px 8px;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.6875rem;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;
}

.settings-workspace__set-primary-btn:hover {
    background: rgba(192, 159, 83, 0.15);
    border-color: rgba(192, 159, 83, 0.4);
    color: #c0a053;
}

.settings-workspace__set-primary-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.settings-workspace__remove-domain-btn {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    border: 1px solid rgba(220, 100, 100, 0.3);
    background: rgba(220, 80, 80, 0.12);
    color: #f0c4c4;
    font-size: 1rem;
    line-height: 1;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;
}

.settings-workspace__remove-domain-btn:hover {
    background: rgba(220, 80, 80, 0.25);
    border-color: rgba(220, 100, 100, 0.5);
}

.settings-workspace__remove-domain-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.settings-workspace__no-domains {
    margin: 0;
    padding: 14px;
    font-size: 0.8125rem;
    color: rgba(180, 180, 180, 0.7);
    text-align: center;
    border-radius: 10px;
    border: 1px dashed rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
}

/* Domains cell in table */
.settings-workspace__domains-cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.settings-workspace__domain-count {
    font-size: 0.6875rem;
    color: rgba(180, 180, 180, 0.75);
    font-weight: 500;
}

/* Domain verification badge */
.settings-workspace__verify-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.625rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.settings-workspace__verify-badge--verified {
    background: rgba(80, 180, 100, 0.15);
    border: 1px solid rgba(80, 180, 100, 0.3);
    color: #7dd590;
}

.settings-workspace__verify-badge--unverified {
    background: rgba(220, 160, 60, 0.15);
    border: 1px solid rgba(220, 160, 60, 0.3);
    color: #e8c76a;
}

.settings-workspace__verify-badge--expired {
    background: rgba(220, 100, 80, 0.15);
    border: 1px solid rgba(220, 100, 80, 0.3);
    color: #f0a8a0;
}

.settings-workspace__verify-badge--unknown {
    background: rgba(150, 150, 150, 0.15);
    border: 1px solid rgba(150, 150, 150, 0.3);
    color: #aaa;
}

.settings-workspace__verify-icon {
    font-size: 0.75rem;
}

.settings-workspace__verify-btn {
    padding: 4px 10px;
    border-radius: 6px;
    border: 1px solid rgba(192, 159, 83, 0.3);
    background: rgba(192, 159, 83, 0.1);
    color: #c9a855;
    font-size: 0.6875rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;
}

.settings-workspace__verify-btn:hover {
    background: rgba(192, 159, 83, 0.2);
    border-color: rgba(192, 159, 83, 0.5);
}

.settings-workspace__verify-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Domain Verification Modal */
.settings-verify-modal__domain {
    margin: 0 0 20px;
    padding: 10px 14px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.1);
    font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
    font-size: 0.9375rem;
    color: #f0f0f0;
}

.settings-verify-modal__instructions {
    margin-bottom: 20px;
}

.settings-verify-modal__intro {
    margin: 0 0 16px;
    font-size: 0.875rem;
    color: rgba(197, 197, 197, 0.9);
    line-height: 1.5;
}

.settings-verify-modal__method {
    margin-bottom: 18px;
    padding: 14px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.08);
}

.settings-verify-modal__method h4 {
    margin: 0 0 8px;
    font-size: 0.8125rem;
    font-weight: 600;
    color: rgba(192, 159, 83, 0.95);
}

.settings-verify-modal__method p {
    margin: 0 0 10px;
    font-size: 0.8125rem;
    color: rgba(180, 180, 180, 0.85);
    line-height: 1.45;
}

.settings-verify-modal__method code {
    background: rgba(0, 0, 0, 0.3);
    padding: 1px 4px;
    border-radius: 3px;
    font-size: 0.75rem;
}

.settings-verify-modal__code-block {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.06);
    overflow-x: auto;
}

.settings-verify-modal__code-block code {
    flex: 1;
    font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
    font-size: 0.75rem;
    color: #b8e0b8;
    background: transparent;
    padding: 0;
    white-space: nowrap;
}

.settings-verify-modal__copy-btn {
    flex-shrink: 0;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.08);
    color: #ccc;
    font-size: 0.6875rem;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s ease;
}

.settings-verify-modal__copy-btn:hover {
    background: rgba(255, 255, 255, 0.15);
}

.settings-verify-modal__token-info {
    margin-top: 14px;
    padding: 10px 14px;
    border-radius: 8px;
    background: rgba(192, 159, 83, 0.08);
    border: 1px solid rgba(192, 159, 83, 0.2);
    font-size: 0.8125rem;
    color: rgba(197, 197, 197, 0.9);
}

.settings-verify-modal__token-info strong {
    color: rgba(192, 159, 83, 0.95);
}

.settings-verify-modal__token {
    display: block;
    margin-top: 6px;
    padding: 6px 10px;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.25);
    font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
    font-size: 0.75rem;
    color: #d4b87a;
    word-break: break-all;
}

.settings-verify-modal__result {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    padding: 12px 14px;
    border-radius: 8px;
    font-size: 0.8125rem;
    font-weight: 500;
}

.settings-verify-modal__result--success {
    background: rgba(80, 180, 100, 0.12);
    border: 1px solid rgba(80, 180, 100, 0.3);
    color: #7dd590;
}

.settings-verify-modal__result--error {
    background: rgba(220, 100, 80, 0.12);
    border: 1px solid rgba(220, 100, 80, 0.3);
    color: #f0a8a0;
}

.settings-verify-modal__result-icon {
    font-size: 1rem;
}

.settings-verify-modal__status {
    margin-top: 16px;
    padding: 12px 14px;
    border-radius: 8px;
    background: rgba(80, 180, 100, 0.08);
    border: 1px solid rgba(80, 180, 100, 0.2);
    font-size: 0.8125rem;
}

.settings-verify-modal__status p {
    margin: 0;
    color: rgba(180, 200, 180, 0.9);
}

.settings-verify-modal__status p + p {
    margin-top: 6px;
}

.settings-verify-modal__status strong {
    color: #7dd590;
}

/* ── Analytics Script settings page ─────────────────────────────────────── */

.settings-section {
    max-width: 760px;
    padding: 4px 0 48px;
}

.as-intro {
    margin-bottom: 24px;
}

.as-intro p {
    margin: 0;
    font-size: 0.9375rem;
    line-height: 1.6;
    color: rgba(197, 197, 197, 0.9);
}

.as-domain-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
}

.as-label {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.9);
    white-space: nowrap;
}

.as-select {
    background: rgba(0, 0, 0, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 8px;
    color: #ececec;
    font-size: 0.9rem;
    padding: 6px 10px;
    min-width: 220px;
    cursor: pointer;
}

.as-select:focus {
    outline: 2px solid rgba(192, 159, 83, 0.5);
    outline-offset: 2px;
}

.as-error {
    margin: 0 0 16px;
    padding: 10px 14px;
    border-radius: 10px;
    font-size: 0.875rem;
    background: rgba(220, 80, 80, 0.1);
    border: 1px solid rgba(220, 100, 100, 0.3);
    color: #f5aeae;
}

.as-loading {
    color: rgba(160, 160, 160, 0.8);
    font-size: 0.875rem;
    margin: 0;
}

.as-empty {
    padding: 28px 24px;
    border-radius: 14px;
    border: 1px dashed rgba(255, 255, 255, 0.12);
    background: rgba(0, 0, 0, 0.15);
    text-align: center;
}

.as-empty p {
    margin: 0 0 16px;
    color: rgba(197, 197, 197, 0.8);
    font-size: 0.9375rem;
}

.as-generate-btn {
    display: inline-flex;
    align-items: center;
    padding: 9px 20px;
    border-radius: 10px;
    border: 1px solid rgba(192, 159, 83, 0.5);
    background: rgba(192, 159, 83, 0.12);
    color: rgba(227, 200, 130, 0.95);
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
}

.as-generate-btn:hover:not(:disabled) {
    background: rgba(192, 159, 83, 0.22);
    border-color: rgba(192, 159, 83, 0.7);
}

.as-generate-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.as-card {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 24px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(165deg, rgba(58, 58, 62, 0.55) 0%, rgba(36, 36, 40, 0.75) 100%);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.as-key-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
}

.as-key-row > div:first-child {
    display: flex;
    align-items: baseline;
    gap: 12px;
}

.as-key-value {
    font-family: "SF Mono", "Fira Code", "Cascadia Code", monospace;
    font-size: 0.95rem;
    color: #ececec;
    letter-spacing: 0.04em;
}

.as-key-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.as-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 3px 10px;
    border-radius: 999px;
}

.as-status::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
}

.as-status--active {
    background: rgba(74, 222, 128, 0.12);
    color: #6ee7a0;
    border: 1px solid rgba(74, 222, 128, 0.25);
}

.as-status--active::before {
    background: #4ade80;
}

.as-status--inactive {
    background: rgba(160, 160, 160, 0.1);
    color: rgba(180, 180, 180, 0.8);
    border: 1px solid rgba(160, 160, 160, 0.2);
}

.as-status--inactive::before {
    background: rgba(180, 180, 180, 0.6);
}

.as-copy-btn {
    padding: 5px 13px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(200, 200, 200, 0.9);
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.18s, border-color 0.18s, color 0.18s;
    white-space: nowrap;
}

.as-copy-btn:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.22);
    color: #ececec;
}

.as-copy-btn--done {
    background: rgba(74, 222, 128, 0.14);
    border-color: rgba(74, 222, 128, 0.35);
    color: #6ee7a0;
}

.as-snippet {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.as-snippet__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.as-snippet__label {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.9);
}

.as-snippet__code {
    margin: 0;
    padding: 14px 16px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: rgba(0, 0, 0, 0.35);
    font-family: "SF Mono", "Fira Code", "Cascadia Code", monospace;
    font-size: 0.8rem;
    line-height: 1.7;
    color: #c9e9a0;
    white-space: pre-wrap;
    word-break: break-all;
    overflow-x: auto;
}

.as-snippet__hint {
    margin: 0;
    font-size: 0.8125rem;
    color: rgba(170, 170, 170, 0.75);
    line-height: 1.55;
}

.as-snippet__hint code {
    font-family: "SF Mono", "Fira Code", "Cascadia Code", monospace;
    font-size: 0.8em;
    background: rgba(255, 255, 255, 0.07);
    border-radius: 4px;
    padding: 1px 5px;
    color: #d4b896;
}

.as-privacy-note {
    padding: 18px 20px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: rgba(0, 0, 0, 0.2);
}

.as-privacy-note__title {
    margin: 0 0 14px;
    font-size: 0.8125rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(180, 180, 180, 0.7);
}

.as-privacy-note__cols {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px 24px;
}

@media (max-width: 560px) {
    .as-privacy-note__cols {
        grid-template-columns: 1fr;
    }
}

.as-privacy-note__list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.as-privacy-note__list li {
    font-size: 0.8125rem;
    line-height: 1.45;
    padding-left: 18px;
    position: relative;
    color: rgba(197, 197, 197, 0.82);
}

.as-privacy-note__list li::before {
    position: absolute;
    left: 0;
    top: 0;
    font-size: 0.8rem;
}

.as-privacy-note__list--yes li::before {
    content: "✓";
    color: #4ade80;
}

.as-privacy-note__list--no li::before {
    content: "✕";
    color: rgba(239, 68, 68, 0.8);
}

/* ── Automatic event tracking (dataLayer) + Lead quality sections ────────────── */

.as-section-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.as-section-title {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: #ececec;
}

.as-section-hint {
    margin: -8px 0 0;
    font-size: 0.82rem;
    line-height: 1.5;
    color: rgba(180, 180, 180, 0.75);
}

.as-section-hint code {
    background: rgba(255, 255, 255, 0.06);
    padding: 1px 5px;
    border-radius: 4px;
    font-size: 0.78rem;
}

.as-panel__sub {
    margin: 0;
    font-size: 0.82rem;
    color: rgba(130, 130, 130, 0.6);
}

/* Toggle switch */
.as-toggle {
    position: relative;
    display: inline-flex;
    cursor: pointer;
    flex-shrink: 0;
}

.as-toggle input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

.as-toggle__track {
    width: 38px;
    height: 22px;
    border-radius: 11px;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: inline-flex;
    align-items: center;
    padding: 2px;
    transition: background 0.15s ease;
}

.as-toggle__thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #ccc;
    transition: transform 0.15s ease;
}

.as-toggle input:checked + .as-toggle__track {
    background: rgba(192, 159, 83, 0.6);
}

.as-toggle input:checked + .as-toggle__track .as-toggle__thumb {
    transform: translateX(16px);
    background: #fff;
}

/* Rule rows (dataLayer mappings) */
.as-rule-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.as-rule-row:last-of-type { border-bottom: none; }

.as-rule-row__body {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.as-rule-row__name {
    font-size: 0.85rem;
    color: rgba(220, 220, 220, 0.92);
}

.as-rule-row__name code {
    background: rgba(255, 255, 255, 0.06);
    padding: 1px 5px;
    border-radius: 4px;
}

.as-rule-row__paths {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    font-size: 0.72rem;
    color: rgba(150, 150, 150, 0.65);
}

.as-rule-row__paths code {
    color: rgba(180, 210, 180, 0.85);
}

.as-rule-row__delete {
    background: none;
    border: 1px solid rgba(220, 100, 80, 0.3);
    color: rgba(230, 140, 140, 0.85);
    font-size: 0.72rem;
    padding: 4px 10px;
    border-radius: 6px;
    cursor: pointer;
    flex-shrink: 0;
}

.as-rule-row__delete:hover { background: rgba(220, 100, 80, 0.12); }

/* Rule form (add a dataLayer mapping) */
.as-rule-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 14px;
    margin-top: 12px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
}

.as-rule-form__row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.as-rule-form__row label {
    width: 160px;
    flex-shrink: 0;
    font-size: 0.78rem;
    color: rgba(180, 180, 180, 0.75);
}

.as-rule-form__row input,
.as-rule-form__row select {
    flex: 1;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    color: rgba(220, 220, 220, 0.9);
    font-size: 0.82rem;
    padding: 7px 10px;
}

.as-rule-form__actions {
    display: flex;
    gap: 10px;
    margin-top: 4px;
}

.as-cancel-btn {
    background: none;
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: rgba(200, 200, 200, 0.8);
    font-size: 0.82rem;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
}

/* Lead quality */
.as-checkbox-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.85rem;
    color: rgba(210, 210, 210, 0.88);
    cursor: pointer;
}

.as-field-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.as-tag-editor {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.as-tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    min-height: 24px;
}

.as-tag-list__empty {
    font-size: 0.78rem;
    color: rgba(130, 130, 130, 0.55);
}

.as-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(192, 159, 83, 0.12);
    border: 1px solid rgba(192, 159, 83, 0.3);
    color: rgba(230, 210, 160, 0.95);
    font-size: 0.78rem;
    padding: 4px 6px 4px 10px;
    border-radius: 999px;
}

.as-tag button {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    font-size: 0.9rem;
    line-height: 1;
    padding: 0 2px;
}

.as-tag-add {
    display: flex;
    gap: 8px;
}

.as-tag-add input {
    flex: 1;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    color: rgba(220, 220, 220, 0.9);
    font-size: 0.82rem;
    padding: 7px 10px;
}

.as-tag-add button {
    background: rgba(192, 159, 83, 0.4);
    border: none;
    color: #1a1a1e;
    font-weight: 600;
    font-size: 0.78rem;
    padding: 7px 14px;
    border-radius: 8px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Settings/Style.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA,0DAA0D;AAC1D;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,8BAA8B;IAC9B,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,2FAA2F;IAC3F;;+CAE2C;IAC3C,qBAAqB;IACrB,cAAc;IACd;;;;4BAIwB;AAC5B;;AAEA;IACI,sCAAsC;IACtC,2FAA2F;IAC3F;;+CAE2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gDAAgD;IAChD,iDAAiD;IACjD,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,gDAAgD;AAChD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gGAAgG;AACpG;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,oCAAoC;IACpC;;8BAE0B;AAC9B;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,2FAA2F;IAC3F;;+CAE2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,oCAAoC;IACpC,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;IAC/B,cAAc;IACd,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,8CAA8C;AAClD;;AAEA;;IAEI,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,+FAA+F;IAC/F,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf;;;4BAGwB;AAC5B;;AAEA;;IAEI,sCAAsC;IACtC,+FAA+F;AACnG;;AAEA;;IAEI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA,uCAAuC;AACvC;IACI,eAAe;IACf,mBAAmB;IACnB,0CAA0C;IAC1C,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,+BAA+B;IAC/B,iDAAiD;IACjD,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA,6CAA6C;AAC7C;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,0FAA0F;AAC9F;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,oCAAoC;IACpC,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf;;8BAE0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,mBAAmB;IACnB,0CAA0C;IAC1C,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,oCAAoC;IACpC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,2FAA2F;IAC3F,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;IAC/B,cAAc;IACd,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,2CAA2C;IAC3C,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,yFAAyF;AAC7F;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;IAC/B,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI,gFAAgF;IAChF,oBAAoB;IACpB,cAAc;IACd,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA,+BAA+B;AAC/B;IACI,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,oCAAoC;IACpC,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,0CAA0C;IAC1C,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,mCAAmC;IACnC,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,oCAAoC;IACpC,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,0CAA0C;IAC1C,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,kDAAkD;IAClD,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,oBAAoB;IACpB,gFAAgF;IAChF,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;IAC3C,qCAAqC;IACrC,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,mCAAmC;IACnC,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,mCAAmC;IACnC,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,0CAA0C;IAC1C,gFAAgF;IAChF,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gFAAgF;IAChF,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,qCAAqC;IACrC,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;IACpC,yCAAyC;IACzC,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;IAC/B,gFAAgF;IAChF,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;IACpC,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,8EAA8E;;AAE9E;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,2CAA2C;IAC3C,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,kCAAkC;IAClC,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;IAC5C,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,oCAAoC;IACpC,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,2FAA2F;IAC3F,oFAAoF;AACxF;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,+DAA+D;IAC/D,kBAAkB;IAClB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;IAC/B,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,qCAAqC;IACrC,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,6DAA6D;IAC7D,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;IAC/B,+DAA+D;IAC/D,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,+DAA+D;IAC/D,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,0CAA0C;IAC1C,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,kDAAkD;AACtD;;AAEA,4BAA4B,mBAAmB,EAAE;;AAEjD;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA,6BAA6B,oCAAoC,EAAE;;AAEnE,wCAAwC;AACxC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;;IAEI,OAAO;IACP,qCAAqC;IACrC,0CAA0C;IAC1C,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;IAC3C,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,oCAAoC;IACpC,yCAAyC;IACzC,gCAAgC;IAChC,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,qCAAqC;IACrC,0CAA0C;IAC1C,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".settingsNavItem {\n    display: inline-block;\n    padding: 15px;\n    color: inherit;\n    text-decoration: none;\n}\n\n.settingsNavItem:hover {\n    background-color: rgb(197, 197, 197);\n    color: initial;\n    border-radius: 10px;\n}\n\n.my-0 {\n    margin: 0;\n}\n\n/* Settings index hub (aligned with Reports hub styling) */\n.settings-hub {\n    padding: 8px 0 48px;\n    max-width: 960px;\n}\n\n.settings-hub__intro {\n    margin: 0 0 24px;\n    font-size: 0.9375rem;\n    line-height: 1.55;\n    color: rgba(197, 197, 197, 0.92);\n}\n\n.settings-hub__scope {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 28px;\n    padding: 8px 14px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: rgba(0, 0, 0, 0.2);\n    font-size: 0.8125rem;\n    color: rgba(197, 197, 197, 0.88);\n}\n\n.settings-hub__scope-label {\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    font-size: 0.65rem;\n    color: rgba(192, 159, 83, 0.95);\n}\n\n.settings-hub__scope-value {\n    font-weight: 500;\n    color: #ececec;\n    word-break: break-word;\n}\n\n.settings-hub__empty {\n    margin: 0;\n    font-size: 0.875rem;\n    color: rgba(180, 180, 180, 0.9);\n}\n\n.settings-hub__grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n    gap: 16px;\n}\n\n.settings-hub__card {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n    padding: 20px 20px 18px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: linear-gradient(165deg, rgba(58, 58, 62, 0.55) 0%, rgba(36, 36, 40, 0.75) 100%);\n    box-shadow:\n        0 12px 32px rgba(0, 0, 0, 0.22),\n        inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    text-decoration: none;\n    color: inherit;\n    transition:\n        border-color 0.2s ease,\n        background 0.2s ease,\n        transform 0.2s ease,\n        box-shadow 0.2s ease;\n}\n\n.settings-hub__card:hover {\n    border-color: rgba(192, 159, 83, 0.35);\n    background: linear-gradient(165deg, rgba(68, 64, 58, 0.45) 0%, rgba(40, 38, 34, 0.85) 100%);\n    box-shadow:\n        0 16px 40px rgba(0, 0, 0, 0.28),\n        inset 0 1px 0 rgba(255, 255, 255, 0.06);\n    transform: translateY(-1px);\n}\n\n.settings-hub__card:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.65);\n    outline-offset: 3px;\n}\n\n.settings-hub__card-title {\n    margin: 0 0 8px;\n    font-size: 1.05rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    color: #f2f2f2;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n}\n\n.settings-hub__card-arrow {\n    flex-shrink: 0;\n    width: 10px;\n    height: 10px;\n    margin-left: auto;\n    border-right: 2px solid rgba(192, 159, 83, 0.75);\n    border-bottom: 2px solid rgba(192, 159, 83, 0.75);\n    transform: rotate(-45deg);\n    margin-top: 2px;\n}\n\n.settings-hub__card-desc {\n    margin: 0;\n    font-size: 0.8125rem;\n    line-height: 1.5;\n    color: rgba(180, 180, 180, 0.95);\n}\n\n@media screen and (max-width: 600px) {\n    .settings-hub__grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* ——— Shared layout for Settings subpages ——— */\n.settings-subpage {\n    max-width: 720px;\n    padding: 8px 0 56px;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif;\n}\n\n.settings-subpage--wide {\n    max-width: 960px;\n}\n\n.settings-subpage__intro {\n    margin: 0 0 20px;\n    font-size: 0.9375rem;\n    line-height: 1.55;\n    color: rgba(197, 197, 197, 0.9);\n}\n\n.settings-subpage__toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px 20px;\n    margin-bottom: 18px;\n}\n\n.settings-subpage__toolbar .cta {\n    margin-top: 0;\n}\n\n.settings-subpage__back {\n    display: inline-flex;\n    align-items: center;\n    margin-bottom: 18px;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #8f9aad;\n    text-decoration: none;\n    border-bottom: 1px solid transparent;\n    transition:\n        color 0.2s ease,\n        border-color 0.2s ease;\n}\n\n.settings-subpage__back:hover {\n    color: #c0a053;\n    border-bottom-color: rgba(192, 159, 83, 0.45);\n}\n\n.settings-subpage__panel {\n    padding: 22px 22px 24px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: linear-gradient(165deg, rgba(52, 52, 56, 0.55) 0%, rgba(28, 28, 32, 0.72) 100%);\n    box-shadow:\n        0 12px 32px rgba(0, 0, 0, 0.22),\n        inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    margin-bottom: 20px;\n}\n\n.settings-subpage__panel--flush {\n    padding: 0;\n    overflow: hidden;\n}\n\n.settings-subpage__status {\n    margin: 0 0 16px;\n    padding: 10px 14px;\n    border-radius: 10px;\n    font-size: 0.875rem;\n    background: rgba(192, 159, 83, 0.12);\n    border: 1px solid rgba(192, 159, 83, 0.25);\n    color: #e8dcc8;\n}\n\n.settings-subpage__status--error {\n    background: rgba(220, 80, 80, 0.12);\n    border-color: rgba(220, 100, 100, 0.35);\n    color: #f0c4c4;\n}\n\n.settings-subpage__form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.settings-subpage__field-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px 20px;\n}\n\n.settings-subpage__field-row label {\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #d8d8d8;\n    min-width: 140px;\n}\n\n.settings-subpage__select {\n    flex: 1;\n    min-width: 200px;\n    padding: 10px 12px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    background: rgba(0, 0, 0, 0.25);\n    color: #f0f0f0;\n    font-size: 0.875rem;\n    font-family: inherit;\n}\n\n.settings-subpage__select:focus {\n    outline: none;\n    border-color: rgba(192, 159, 83, 0.45);\n    box-shadow: 0 0 0 2px rgba(192, 159, 83, 0.15);\n}\n\n.settings-subpage__submit,\n.settings-subpage .cta {\n    align-self: flex-start;\n    margin-top: 8px;\n    padding: 11px 22px;\n    border-radius: 10px;\n    border: 1px solid rgba(192, 159, 83, 0.45);\n    background: linear-gradient(180deg, rgba(192, 159, 83, 0.22) 0%, rgba(160, 130, 70, 0.18) 100%);\n    color: #f5f0e6;\n    font-size: 0.875rem;\n    font-weight: 600;\n    font-family: inherit;\n    cursor: pointer;\n    transition:\n        border-color 0.2s ease,\n        background 0.2s ease,\n        transform 0.15s ease;\n}\n\n.settings-subpage__submit:hover,\n.settings-subpage .cta:hover {\n    border-color: rgba(192, 159, 83, 0.65);\n    background: linear-gradient(180deg, rgba(192, 159, 83, 0.32) 0%, rgba(160, 130, 70, 0.26) 100%);\n}\n\n.settings-subpage__submit:focus-visible,\n.settings-subpage .cta:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.65);\n    outline-offset: 2px;\n}\n\n.settings-subpage__submit:disabled,\n.settings-subpage .cta:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    transform: none;\n}\n\n/* Data tables (users, organisations) */\n.settings-table-wrap {\n    margin-top: 8px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: rgba(0, 0, 0, 0.2);\n    overflow-x: auto;\n}\n\n.settings-table {\n    width: 100%;\n    min-width: 560px;\n    border-collapse: collapse;\n    font-size: 0.875rem;\n    color: #e0e0e0;\n}\n\n.settings-table th {\n    text-align: left;\n    padding: 12px 16px;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.95);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    background: rgba(0, 0, 0, 0.25);\n}\n\n.settings-table td {\n    padding: 14px 16px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    vertical-align: middle;\n}\n\n.settings-table tr:last-child td {\n    border-bottom: none;\n}\n\n.settings-table tbody tr:hover td {\n    background: rgba(255, 255, 255, 0.03);\n}\n\n.settings-table .cta {\n    margin-top: 0;\n    padding: 8px 14px;\n    font-size: 0.8125rem;\n}\n\n.settings-subpage__empty {\n    margin: 0;\n    padding: 24px 16px;\n    text-align: center;\n    font-size: 0.875rem;\n    color: rgba(180, 180, 180, 0.85);\n}\n\n/* Blacklist IP (page-specific, dark theme) */\n.settings-blacklist__toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 20px;\n    padding: 16px 18px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: linear-gradient(165deg, rgba(52, 52, 56, 0.5) 0%, rgba(28, 28, 32, 0.65) 100%);\n}\n\n.settings-blacklist__toolbar p {\n    margin: 0;\n    font-size: 0.875rem;\n    color: rgba(197, 197, 197, 0.92);\n    line-height: 1.45;\n}\n\n.settings-blacklist__ip {\n    font-weight: 600;\n    color: #c0a053;\n}\n\n.settings-blacklist__add {\n    flex-shrink: 0;\n    width: 44px;\n    height: 44px;\n    border-radius: 12px;\n    border: 1px solid rgba(192, 159, 83, 0.4);\n    background: rgba(192, 159, 83, 0.15);\n    color: #f0e6d2;\n    font-size: 1.5rem;\n    line-height: 1;\n    cursor: pointer;\n    transition:\n        background 0.2s ease,\n        border-color 0.2s ease;\n}\n\n.settings-blacklist__add:hover {\n    background: rgba(192, 159, 83, 0.28);\n    border-color: rgba(192, 159, 83, 0.6);\n}\n\n.settings-blacklist__list {\n    list-style: none;\n    margin: 0;\n    padding: 8px 0;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: rgba(0, 0, 0, 0.22);\n}\n\n.settings-blacklist__item {\n    padding: 12px 18px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    font-family: ui-monospace, monospace;\n    font-size: 0.875rem;\n    color: #e4e4e4;\n}\n\n.settings-blacklist__item:last-child {\n    border-bottom: none;\n}\n\n.settings-blacklist-modal {\n    position: fixed;\n    inset: 0;\n    z-index: 220;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    background: rgba(0, 0, 0, 0.65);\n    backdrop-filter: blur(6px);\n}\n\n.settings-blacklist-modal__card {\n    width: 100%;\n    max-width: 420px;\n    padding: 24px 22px 22px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    background: linear-gradient(168deg, rgba(48, 48, 52, 0.98) 0%, rgba(24, 24, 28, 0.99) 100%);\n    box-shadow: 0 24px 56px rgba(0, 0, 0, 0.5);\n}\n\n.settings-blacklist-modal__card h2 {\n    margin: 0 0 16px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #f2f2f2;\n}\n\n.settings-blacklist-modal__card input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 10px 12px;\n    margin-bottom: 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    background: rgba(0, 0, 0, 0.35);\n    color: #f0f0f0;\n    font-size: 0.875rem;\n    font-family: ui-monospace, monospace;\n}\n\n.settings-blacklist-modal__card input:focus {\n    outline: none;\n    border-color: rgba(192, 159, 83, 0.5);\n}\n\n.settings-blacklist-modal__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    justify-content: flex-end;\n}\n\n.settings-blacklist-modal__btn {\n    padding: 10px 18px;\n    border-radius: 10px;\n    font-size: 0.875rem;\n    font-weight: 600;\n    font-family: inherit;\n    cursor: pointer;\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    background: rgba(255, 255, 255, 0.06);\n    color: #e0e0e0;\n}\n\n.settings-blacklist-modal__btn--primary {\n    border-color: rgba(192, 159, 83, 0.45);\n    background: rgba(192, 159, 83, 0.2);\n    color: #faf6ee;\n}\n\n.settings-blacklist-modal__btn--danger {\n    border-color: rgba(220, 100, 100, 0.5);\n    background: rgba(160, 50, 50, 0.22);\n    color: #ffd8d8;\n}\n\n.settings-blacklist-modal__btn:hover {\n    filter: brightness(1.08);\n}\n\n.settings-org-modal__divider {\n    margin: 20px 0 14px;\n    border: none;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.settings-org-modal__danger-title {\n    margin: 0 0 8px;\n    font-size: 0.6875rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(255, 160, 160, 0.85);\n}\n\n.settings-org-modal__danger-desc {\n    margin: 0 0 12px;\n    font-size: 0.8125rem;\n    line-height: 1.45;\n    color: rgba(190, 190, 190, 0.95);\n}\n\n.settings-blacklist-modal__card .settings-org-modal__text-input {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.settings-blacklist-modal__card .settings-org-modal__select {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 10px 12px;\n    margin-bottom: 14px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    background: rgba(0, 0, 0, 0.35);\n    color: #f0f0f0;\n    font-size: 0.875rem;\n    font-family: inherit;\n    cursor: pointer;\n}\n\n.settings-blacklist-modal__card .settings-org-modal__select:focus {\n    outline: none;\n    border-color: rgba(192, 159, 83, 0.5);\n}\n\n.settings-org-modal__field-block {\n    margin-bottom: 14px;\n}\n\n.settings-org-modal__label {\n    display: block;\n    margin-bottom: 6px;\n    font-size: 0.8125rem;\n    font-weight: 600;\n    color: #c8c8c8;\n}\n\n/* Workspace-specific styles */\n.settings-workspace__domain {\n    font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, monospace;\n    font-size: 0.8125rem;\n    color: #c0a053;\n    background: rgba(192, 159, 83, 0.1);\n    padding: 3px 8px;\n    border-radius: 6px;\n    border: 1px solid rgba(192, 159, 83, 0.2);\n}\n\n.settings-workspace__description {\n    color: rgba(180, 180, 180, 0.85);\n    font-size: 0.8125rem;\n    max-width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: inline-block;\n}\n\n.settings-workspace__badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    border-radius: 8px;\n    font-size: 0.6875rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.settings-workspace__badge--agency {\n    background: rgba(192, 159, 83, 0.15);\n    border: 1px solid rgba(192, 159, 83, 0.3);\n    color: #c0a053;\n}\n\n.settings-workspace__user-count {\n    font-size: 0.8125rem;\n    color: rgba(180, 180, 180, 0.85);\n}\n\n/* Wider modal for workspaces */\n.settings-blacklist-modal__card--wide {\n    max-width: 520px;\n}\n\n/* User management section */\n.settings-workspace__users-section {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.settings-workspace__users-add {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 12px;\n}\n\n.settings-workspace__user-input {\n    flex: 1;\n    margin-bottom: 0 !important;\n}\n\n.settings-workspace__add-user-btn {\n    flex-shrink: 0;\n    padding: 10px 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(192, 159, 83, 0.45);\n    background: rgba(192, 159, 83, 0.18);\n    color: #f5f0e6;\n    font-size: 0.875rem;\n    font-weight: 600;\n    font-family: inherit;\n    cursor: pointer;\n    transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.settings-workspace__add-user-btn:hover {\n    background: rgba(192, 159, 83, 0.28);\n    border-color: rgba(192, 159, 83, 0.6);\n}\n\n.settings-workspace__add-user-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.settings-workspace__users-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: rgba(0, 0, 0, 0.2);\n    max-height: 180px;\n    overflow-y: auto;\n}\n\n.settings-workspace__user-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 14px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.settings-workspace__user-item:last-child {\n    border-bottom: none;\n}\n\n.settings-workspace__user-email {\n    font-size: 0.8125rem;\n    color: #e4e4e4;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.settings-workspace__remove-user-btn {\n    flex-shrink: 0;\n    width: 24px;\n    height: 24px;\n    border-radius: 6px;\n    border: 1px solid rgba(220, 100, 100, 0.3);\n    background: rgba(220, 80, 80, 0.12);\n    color: #f0c4c4;\n    font-size: 1rem;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.settings-workspace__remove-user-btn:hover {\n    background: rgba(220, 80, 80, 0.25);\n    border-color: rgba(220, 100, 100, 0.5);\n}\n\n.settings-workspace__remove-user-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.settings-workspace__no-users {\n    margin: 0;\n    padding: 14px;\n    font-size: 0.8125rem;\n    color: rgba(180, 180, 180, 0.7);\n    text-align: center;\n    border-radius: 10px;\n    border: 1px dashed rgba(255, 255, 255, 0.1);\n    background: rgba(0, 0, 0, 0.1);\n}\n\n/* Domain management section */\n.settings-workspace__domains-section {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.settings-workspace__domains-add {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 12px;\n}\n\n.settings-workspace__domain-input {\n    flex: 1;\n    margin-bottom: 0 !important;\n}\n\n.settings-workspace__add-domain-btn {\n    flex-shrink: 0;\n    padding: 10px 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(192, 159, 83, 0.45);\n    background: rgba(192, 159, 83, 0.18);\n    color: #f5f0e6;\n    font-size: 0.875rem;\n    font-weight: 600;\n    font-family: inherit;\n    cursor: pointer;\n    transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.settings-workspace__add-domain-btn:hover {\n    background: rgba(192, 159, 83, 0.28);\n    border-color: rgba(192, 159, 83, 0.6);\n}\n\n.settings-workspace__add-domain-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.settings-workspace__domains-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: rgba(0, 0, 0, 0.2);\n    max-height: 180px;\n    overflow-y: auto;\n}\n\n.settings-workspace__domain-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 14px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    gap: 10px;\n}\n\n.settings-workspace__domain-item:last-child {\n    border-bottom: none;\n}\n\n.settings-workspace__domain-info {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n    flex: 1;\n}\n\n.settings-workspace__domain-name {\n    font-size: 0.8125rem;\n    font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, monospace;\n    color: #e4e4e4;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.settings-workspace__primary-badge {\n    flex-shrink: 0;\n    font-size: 0.625rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    padding: 2px 6px;\n    border-radius: 4px;\n    background: rgba(192, 159, 83, 0.25);\n    border: 1px solid rgba(192, 159, 83, 0.4);\n    color: #c0a053;\n}\n\n.settings-workspace__domain-actions {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-shrink: 0;\n}\n\n.settings-workspace__set-primary-btn {\n    padding: 4px 8px;\n    border-radius: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    background: rgba(255, 255, 255, 0.05);\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 0.6875rem;\n    font-weight: 500;\n    font-family: inherit;\n    cursor: pointer;\n    transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.settings-workspace__set-primary-btn:hover {\n    background: rgba(192, 159, 83, 0.15);\n    border-color: rgba(192, 159, 83, 0.4);\n    color: #c0a053;\n}\n\n.settings-workspace__set-primary-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.settings-workspace__remove-domain-btn {\n    flex-shrink: 0;\n    width: 24px;\n    height: 24px;\n    border-radius: 6px;\n    border: 1px solid rgba(220, 100, 100, 0.3);\n    background: rgba(220, 80, 80, 0.12);\n    color: #f0c4c4;\n    font-size: 1rem;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.settings-workspace__remove-domain-btn:hover {\n    background: rgba(220, 80, 80, 0.25);\n    border-color: rgba(220, 100, 100, 0.5);\n}\n\n.settings-workspace__remove-domain-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.settings-workspace__no-domains {\n    margin: 0;\n    padding: 14px;\n    font-size: 0.8125rem;\n    color: rgba(180, 180, 180, 0.7);\n    text-align: center;\n    border-radius: 10px;\n    border: 1px dashed rgba(255, 255, 255, 0.1);\n    background: rgba(0, 0, 0, 0.1);\n}\n\n/* Domains cell in table */\n.settings-workspace__domains-cell {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.settings-workspace__domain-count {\n    font-size: 0.6875rem;\n    color: rgba(180, 180, 180, 0.75);\n    font-weight: 500;\n}\n\n/* Domain verification badge */\n.settings-workspace__verify-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-size: 0.625rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.settings-workspace__verify-badge--verified {\n    background: rgba(80, 180, 100, 0.15);\n    border: 1px solid rgba(80, 180, 100, 0.3);\n    color: #7dd590;\n}\n\n.settings-workspace__verify-badge--unverified {\n    background: rgba(220, 160, 60, 0.15);\n    border: 1px solid rgba(220, 160, 60, 0.3);\n    color: #e8c76a;\n}\n\n.settings-workspace__verify-badge--expired {\n    background: rgba(220, 100, 80, 0.15);\n    border: 1px solid rgba(220, 100, 80, 0.3);\n    color: #f0a8a0;\n}\n\n.settings-workspace__verify-badge--unknown {\n    background: rgba(150, 150, 150, 0.15);\n    border: 1px solid rgba(150, 150, 150, 0.3);\n    color: #aaa;\n}\n\n.settings-workspace__verify-icon {\n    font-size: 0.75rem;\n}\n\n.settings-workspace__verify-btn {\n    padding: 4px 10px;\n    border-radius: 6px;\n    border: 1px solid rgba(192, 159, 83, 0.3);\n    background: rgba(192, 159, 83, 0.1);\n    color: #c9a855;\n    font-size: 0.6875rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.settings-workspace__verify-btn:hover {\n    background: rgba(192, 159, 83, 0.2);\n    border-color: rgba(192, 159, 83, 0.5);\n}\n\n.settings-workspace__verify-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Domain Verification Modal */\n.settings-verify-modal__domain {\n    margin: 0 0 20px;\n    padding: 10px 14px;\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.25);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, monospace;\n    font-size: 0.9375rem;\n    color: #f0f0f0;\n}\n\n.settings-verify-modal__instructions {\n    margin-bottom: 20px;\n}\n\n.settings-verify-modal__intro {\n    margin: 0 0 16px;\n    font-size: 0.875rem;\n    color: rgba(197, 197, 197, 0.9);\n    line-height: 1.5;\n}\n\n.settings-verify-modal__method {\n    margin-bottom: 18px;\n    padding: 14px;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.settings-verify-modal__method h4 {\n    margin: 0 0 8px;\n    font-size: 0.8125rem;\n    font-weight: 600;\n    color: rgba(192, 159, 83, 0.95);\n}\n\n.settings-verify-modal__method p {\n    margin: 0 0 10px;\n    font-size: 0.8125rem;\n    color: rgba(180, 180, 180, 0.85);\n    line-height: 1.45;\n}\n\n.settings-verify-modal__method code {\n    background: rgba(0, 0, 0, 0.3);\n    padding: 1px 4px;\n    border-radius: 3px;\n    font-size: 0.75rem;\n}\n\n.settings-verify-modal__code-block {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 12px;\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.35);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    overflow-x: auto;\n}\n\n.settings-verify-modal__code-block code {\n    flex: 1;\n    font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, monospace;\n    font-size: 0.75rem;\n    color: #b8e0b8;\n    background: transparent;\n    padding: 0;\n    white-space: nowrap;\n}\n\n.settings-verify-modal__copy-btn {\n    flex-shrink: 0;\n    padding: 5px 10px;\n    border-radius: 5px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    background: rgba(255, 255, 255, 0.08);\n    color: #ccc;\n    font-size: 0.6875rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background 0.2s ease;\n}\n\n.settings-verify-modal__copy-btn:hover {\n    background: rgba(255, 255, 255, 0.15);\n}\n\n.settings-verify-modal__token-info {\n    margin-top: 14px;\n    padding: 10px 14px;\n    border-radius: 8px;\n    background: rgba(192, 159, 83, 0.08);\n    border: 1px solid rgba(192, 159, 83, 0.2);\n    font-size: 0.8125rem;\n    color: rgba(197, 197, 197, 0.9);\n}\n\n.settings-verify-modal__token-info strong {\n    color: rgba(192, 159, 83, 0.95);\n}\n\n.settings-verify-modal__token {\n    display: block;\n    margin-top: 6px;\n    padding: 6px 10px;\n    border-radius: 5px;\n    background: rgba(0, 0, 0, 0.25);\n    font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, monospace;\n    font-size: 0.75rem;\n    color: #d4b87a;\n    word-break: break-all;\n}\n\n.settings-verify-modal__result {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 16px;\n    padding: 12px 14px;\n    border-radius: 8px;\n    font-size: 0.8125rem;\n    font-weight: 500;\n}\n\n.settings-verify-modal__result--success {\n    background: rgba(80, 180, 100, 0.12);\n    border: 1px solid rgba(80, 180, 100, 0.3);\n    color: #7dd590;\n}\n\n.settings-verify-modal__result--error {\n    background: rgba(220, 100, 80, 0.12);\n    border: 1px solid rgba(220, 100, 80, 0.3);\n    color: #f0a8a0;\n}\n\n.settings-verify-modal__result-icon {\n    font-size: 1rem;\n}\n\n.settings-verify-modal__status {\n    margin-top: 16px;\n    padding: 12px 14px;\n    border-radius: 8px;\n    background: rgba(80, 180, 100, 0.08);\n    border: 1px solid rgba(80, 180, 100, 0.2);\n    font-size: 0.8125rem;\n}\n\n.settings-verify-modal__status p {\n    margin: 0;\n    color: rgba(180, 200, 180, 0.9);\n}\n\n.settings-verify-modal__status p + p {\n    margin-top: 6px;\n}\n\n.settings-verify-modal__status strong {\n    color: #7dd590;\n}\n\n/* ── Analytics Script settings page ─────────────────────────────────────── */\n\n.settings-section {\n    max-width: 760px;\n    padding: 4px 0 48px;\n}\n\n.as-intro {\n    margin-bottom: 24px;\n}\n\n.as-intro p {\n    margin: 0;\n    font-size: 0.9375rem;\n    line-height: 1.6;\n    color: rgba(197, 197, 197, 0.9);\n}\n\n.as-domain-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 24px;\n}\n\n.as-label {\n    font-size: 0.75rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.9);\n    white-space: nowrap;\n}\n\n.as-select {\n    background: rgba(0, 0, 0, 0.35);\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    border-radius: 8px;\n    color: #ececec;\n    font-size: 0.9rem;\n    padding: 6px 10px;\n    min-width: 220px;\n    cursor: pointer;\n}\n\n.as-select:focus {\n    outline: 2px solid rgba(192, 159, 83, 0.5);\n    outline-offset: 2px;\n}\n\n.as-error {\n    margin: 0 0 16px;\n    padding: 10px 14px;\n    border-radius: 10px;\n    font-size: 0.875rem;\n    background: rgba(220, 80, 80, 0.1);\n    border: 1px solid rgba(220, 100, 100, 0.3);\n    color: #f5aeae;\n}\n\n.as-loading {\n    color: rgba(160, 160, 160, 0.8);\n    font-size: 0.875rem;\n    margin: 0;\n}\n\n.as-empty {\n    padding: 28px 24px;\n    border-radius: 14px;\n    border: 1px dashed rgba(255, 255, 255, 0.12);\n    background: rgba(0, 0, 0, 0.15);\n    text-align: center;\n}\n\n.as-empty p {\n    margin: 0 0 16px;\n    color: rgba(197, 197, 197, 0.8);\n    font-size: 0.9375rem;\n}\n\n.as-generate-btn {\n    display: inline-flex;\n    align-items: center;\n    padding: 9px 20px;\n    border-radius: 10px;\n    border: 1px solid rgba(192, 159, 83, 0.5);\n    background: rgba(192, 159, 83, 0.12);\n    color: rgba(227, 200, 130, 0.95);\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s, border-color 0.2s;\n}\n\n.as-generate-btn:hover:not(:disabled) {\n    background: rgba(192, 159, 83, 0.22);\n    border-color: rgba(192, 159, 83, 0.7);\n}\n\n.as-generate-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.as-card {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding: 24px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: linear-gradient(165deg, rgba(58, 58, 62, 0.55) 0%, rgba(36, 36, 40, 0.75) 100%);\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n.as-key-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n}\n\n.as-key-row > div:first-child {\n    display: flex;\n    align-items: baseline;\n    gap: 12px;\n}\n\n.as-key-value {\n    font-family: \"SF Mono\", \"Fira Code\", \"Cascadia Code\", monospace;\n    font-size: 0.95rem;\n    color: #ececec;\n    letter-spacing: 0.04em;\n}\n\n.as-key-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.as-status {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 0.75rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    padding: 3px 10px;\n    border-radius: 999px;\n}\n\n.as-status::before {\n    content: \"\";\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n}\n\n.as-status--active {\n    background: rgba(74, 222, 128, 0.12);\n    color: #6ee7a0;\n    border: 1px solid rgba(74, 222, 128, 0.25);\n}\n\n.as-status--active::before {\n    background: #4ade80;\n}\n\n.as-status--inactive {\n    background: rgba(160, 160, 160, 0.1);\n    color: rgba(180, 180, 180, 0.8);\n    border: 1px solid rgba(160, 160, 160, 0.2);\n}\n\n.as-status--inactive::before {\n    background: rgba(180, 180, 180, 0.6);\n}\n\n.as-copy-btn {\n    padding: 5px 13px;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    background: rgba(255, 255, 255, 0.05);\n    color: rgba(200, 200, 200, 0.9);\n    font-size: 0.8rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.18s, border-color 0.18s, color 0.18s;\n    white-space: nowrap;\n}\n\n.as-copy-btn:hover {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.22);\n    color: #ececec;\n}\n\n.as-copy-btn--done {\n    background: rgba(74, 222, 128, 0.14);\n    border-color: rgba(74, 222, 128, 0.35);\n    color: #6ee7a0;\n}\n\n.as-snippet {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.as-snippet__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.as-snippet__label {\n    font-size: 0.75rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.9);\n}\n\n.as-snippet__code {\n    margin: 0;\n    padding: 14px 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    background: rgba(0, 0, 0, 0.35);\n    font-family: \"SF Mono\", \"Fira Code\", \"Cascadia Code\", monospace;\n    font-size: 0.8rem;\n    line-height: 1.7;\n    color: #c9e9a0;\n    white-space: pre-wrap;\n    word-break: break-all;\n    overflow-x: auto;\n}\n\n.as-snippet__hint {\n    margin: 0;\n    font-size: 0.8125rem;\n    color: rgba(170, 170, 170, 0.75);\n    line-height: 1.55;\n}\n\n.as-snippet__hint code {\n    font-family: \"SF Mono\", \"Fira Code\", \"Cascadia Code\", monospace;\n    font-size: 0.8em;\n    background: rgba(255, 255, 255, 0.07);\n    border-radius: 4px;\n    padding: 1px 5px;\n    color: #d4b896;\n}\n\n.as-privacy-note {\n    padding: 18px 20px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: rgba(0, 0, 0, 0.2);\n}\n\n.as-privacy-note__title {\n    margin: 0 0 14px;\n    font-size: 0.8125rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(180, 180, 180, 0.7);\n}\n\n.as-privacy-note__cols {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px 24px;\n}\n\n@media (max-width: 560px) {\n    .as-privacy-note__cols {\n        grid-template-columns: 1fr;\n    }\n}\n\n.as-privacy-note__list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.as-privacy-note__list li {\n    font-size: 0.8125rem;\n    line-height: 1.45;\n    padding-left: 18px;\n    position: relative;\n    color: rgba(197, 197, 197, 0.82);\n}\n\n.as-privacy-note__list li::before {\n    position: absolute;\n    left: 0;\n    top: 0;\n    font-size: 0.8rem;\n}\n\n.as-privacy-note__list--yes li::before {\n    content: \"✓\";\n    color: #4ade80;\n}\n\n.as-privacy-note__list--no li::before {\n    content: \"✕\";\n    color: rgba(239, 68, 68, 0.8);\n}\n\n/* ── Automatic event tracking (dataLayer) + Lead quality sections ────────────── */\n\n.as-section-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n}\n\n.as-section-title {\n    margin: 0;\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: #ececec;\n}\n\n.as-section-hint {\n    margin: -8px 0 0;\n    font-size: 0.82rem;\n    line-height: 1.5;\n    color: rgba(180, 180, 180, 0.75);\n}\n\n.as-section-hint code {\n    background: rgba(255, 255, 255, 0.06);\n    padding: 1px 5px;\n    border-radius: 4px;\n    font-size: 0.78rem;\n}\n\n.as-panel__sub {\n    margin: 0;\n    font-size: 0.82rem;\n    color: rgba(130, 130, 130, 0.6);\n}\n\n/* Toggle switch */\n.as-toggle {\n    position: relative;\n    display: inline-flex;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.as-toggle input {\n    position: absolute;\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.as-toggle__track {\n    width: 38px;\n    height: 22px;\n    border-radius: 11px;\n    background: rgba(255, 255, 255, 0.12);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    display: inline-flex;\n    align-items: center;\n    padding: 2px;\n    transition: background 0.15s ease;\n}\n\n.as-toggle__thumb {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background: #ccc;\n    transition: transform 0.15s ease;\n}\n\n.as-toggle input:checked + .as-toggle__track {\n    background: rgba(192, 159, 83, 0.6);\n}\n\n.as-toggle input:checked + .as-toggle__track .as-toggle__thumb {\n    transform: translateX(16px);\n    background: #fff;\n}\n\n/* Rule rows (dataLayer mappings) */\n.as-rule-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 10px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.as-rule-row:last-of-type { border-bottom: none; }\n\n.as-rule-row__body {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n}\n\n.as-rule-row__name {\n    font-size: 0.85rem;\n    color: rgba(220, 220, 220, 0.92);\n}\n\n.as-rule-row__name code {\n    background: rgba(255, 255, 255, 0.06);\n    padding: 1px 5px;\n    border-radius: 4px;\n}\n\n.as-rule-row__paths {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n    font-size: 0.72rem;\n    color: rgba(150, 150, 150, 0.65);\n}\n\n.as-rule-row__paths code {\n    color: rgba(180, 210, 180, 0.85);\n}\n\n.as-rule-row__delete {\n    background: none;\n    border: 1px solid rgba(220, 100, 80, 0.3);\n    color: rgba(230, 140, 140, 0.85);\n    font-size: 0.72rem;\n    padding: 4px 10px;\n    border-radius: 6px;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.as-rule-row__delete:hover { background: rgba(220, 100, 80, 0.12); }\n\n/* Rule form (add a dataLayer mapping) */\n.as-rule-form {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 14px;\n    margin-top: 12px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 10px;\n}\n\n.as-rule-form__row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.as-rule-form__row label {\n    width: 160px;\n    flex-shrink: 0;\n    font-size: 0.78rem;\n    color: rgba(180, 180, 180, 0.75);\n}\n\n.as-rule-form__row input,\n.as-rule-form__row select {\n    flex: 1;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n    color: rgba(220, 220, 220, 0.9);\n    font-size: 0.82rem;\n    padding: 7px 10px;\n}\n\n.as-rule-form__actions {\n    display: flex;\n    gap: 10px;\n    margin-top: 4px;\n}\n\n.as-cancel-btn {\n    background: none;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    color: rgba(200, 200, 200, 0.8);\n    font-size: 0.82rem;\n    padding: 8px 16px;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n/* Lead quality */\n.as-checkbox-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.85rem;\n    color: rgba(210, 210, 210, 0.88);\n    cursor: pointer;\n}\n\n.as-field-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.as-tag-editor {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.as-tag-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    min-height: 24px;\n}\n\n.as-tag-list__empty {\n    font-size: 0.78rem;\n    color: rgba(130, 130, 130, 0.55);\n}\n\n.as-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    background: rgba(192, 159, 83, 0.12);\n    border: 1px solid rgba(192, 159, 83, 0.3);\n    color: rgba(230, 210, 160, 0.95);\n    font-size: 0.78rem;\n    padding: 4px 6px 4px 10px;\n    border-radius: 999px;\n}\n\n.as-tag button {\n    background: none;\n    border: none;\n    color: inherit;\n    cursor: pointer;\n    font-size: 0.9rem;\n    line-height: 1;\n    padding: 0 2px;\n}\n\n.as-tag-add {\n    display: flex;\n    gap: 8px;\n}\n\n.as-tag-add input {\n    flex: 1;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n    color: rgba(220, 220, 220, 0.9);\n    font-size: 0.82rem;\n    padding: 7px 10px;\n}\n\n.as-tag-add button {\n    background: rgba(192, 159, 83, 0.4);\n    border: none;\n    color: #1a1a1e;\n    font-weight: 600;\n    font-size: 0.78rem;\n    padding: 7px 14px;\n    border-radius: 8px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
